module.exports = __webpack_public_path__ + "media/application/images/svgs/briefcase-6bb3b770f940b3557c9716d0c770957e.svg";